/* eslint-disable max-len */
import getConfig from 'src/common/config/index';
import { appendParamsToUrl } from 'src/common/url';

const globalConfig = getConfig();

export const goLogin = () => {
  // const href = appendParamsToUrl(window.location.href, { isLoginReturn: 'true' });
  // window.location.href = `${globalConfig.alphaOrigin}/#/login/webrefresh?return_to=${encodeURIComponent(href)}`;
  window.location.href = `${globalConfig.alphaOrigin}/#/login`;
};

export const getIsLogin = () => Boolean(localStorage.getItem('token'));

export const setToken = (token: string) => {
  localStorage.setItem('token', token);
};

export default {};
